import { Box, Text } from '@nimbus-ds/components';
import { TrashIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import { MetaplanItemResponseDto } from '@tiendanube/common';
import { ActionIconButton, InternalNavLink } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { SubscriptionConditions } from 'domains/Catalog/Subscriptions/components';

interface MetaplansListRowProps {
  metaplan: MetaplanItemResponseDto;
  index: number;
}

export function MetaplansListMobileRow({
  metaplan,
  index,
}: Readonly<MetaplansListRowProps>) {
  const t = useTranslationCatalog();

  const handleDelete = (): void => {
    // TODO(juanrevello): Implement delete modal and action (ETA: Nov 2025, week 1)
  };

  return (
    <DataList.Row backgroundColor="transparent" topDivider={index !== 0}>
      <Box display="flex" flexDirection="column" alignItems="stretch" gap="3">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <InternalNavLink to={metaplan.id}>
            <Text color="primary-interactive" fontWeight="regular">
              {metaplan.name}
            </Text>
          </InternalNavLink>
          <Box display="flex" justifyContent="flex-end" gap="2">
            <ActionIconButton
              content={t('subscriptions.table.deleteMetaplan')}
              source={<TrashIcon />}
              onClick={handleDelete}
            />
          </Box>
        </Box>
        <SubscriptionConditions
          subscriptionOptions={metaplan.subscriptionOptions}
        />
      </Box>
    </DataList.Row>
  );
}
